var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-container", attrs: { id: "PTV-content" } },
      [
        _vm.showLoadingScreen
          ? _c("MMP_LoadingScreen", {
              staticClass: "loading",
              attrs: { user: _vm.user },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("NavBar", {
          attrs: {
            menuCollapsed: _vm.menuCollapsed,
            mapsMode: _vm.mapsMode,
            versionReleaseInfo: _vm.versionReleaseInfo,
          },
          on: {
            initMaps: function ($event) {
              return _vm.initMaps()
            },
            destroyMap: function ($event) {
              return _vm.destroyMap()
            },
            vehiclesMap: _vm.initVehiclesMap,
            mapSelection: function ($event) {
              _vm.mapsMode = true
            },
            loadProject: function ($event) {
              return _vm.loadProject($event)
            },
            reset: function ($event) {
              return _vm.reset($event)
            },
            toggleCollapse: _vm.toggleCollapse,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-content" },
          [
            !_vm.mapsMode
              ? _c("Dashboard", {
                  staticClass: "dashboard",
                  attrs: {
                    user: _vm.user,
                    layers: _vm.vehicleLayersButtonsCtrl,
                  },
                  on: {
                    vehiclesMap: _vm.initVehiclesMap,
                    mapResize: _vm.onDashboardMapResize,
                    "toggle-layer": _vm.toggleVehicleLayer,
                    "reorder-layers": _vm.reorderVehicleLayers,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mapsMode
              ? _c(
                  "div",
                  { staticClass: "maps-content" },
                  [
                    _c("div", {
                      staticStyle: { height: "100%", width: "100%" },
                      attrs: { id: "generic-map" },
                    }),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("Generic_ZoomLevel", {
                          staticClass: "ptv-zoom-position",
                          attrs: { map: _vm.map },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("Generic_Tools", {
                          staticClass: "lat-long-position",
                          attrs: {
                            measurement: _vm.measurement,
                            showMeasuringTool: _vm.showMeasuringTool,
                            clickedCoords: _vm.clickedCoords,
                            mapsMode: _vm.mapsMode,
                            map: _vm.map,
                            selectedRelease: _vm.selectedRelease,
                          },
                          on: {
                            addPoint: function ($event) {
                              return _vm.addPoint($event)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode && _vm.showMeasuringTool
                      ? _c("Generic_Measurement", {
                          staticClass: "measurement-position",
                          attrs: {
                            showMeasuringTool: _vm.showMeasuringTool,
                            measurement: _vm.measurement,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("Generic_Widgets", {
                          staticClass: "widget-position",
                          attrs: {
                            currentBaseMap: _vm.currentBaseMap,
                            map: _vm.map,
                            selectedExtent: _vm.selectedExtent,
                            lidarMinZoomAchieved: _vm.lidarMinZoomAchieved,
                            distinct_lidar: _vm.distinct_lidar,
                            lidarIsLoading: _vm.lidarIsLoading,
                            zoomLevel: _vm.zoomLevel,
                            user: this.user,
                            selectedRelease: _vm.selectedRelease,
                          },
                          on: {
                            toggleBaseLayer: function ($event) {
                              return _vm.toggleBaseLayer($event)
                            },
                            toggleMeasuringTool: function ($event) {
                              return _vm.toggleMeasuringTool()
                            },
                            measurement: function ($event) {
                              _vm.measurement = $event
                            },
                            toggleLidarPanel: function ($event) {
                              return _vm.toggleLidarPanel()
                            },
                            extentChanged: function ($event) {
                              return _vm.widgetExtentChanged($event)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("Generic_LayerList", {
                          staticClass: "layer-list-position",
                          attrs: {
                            drtLayersButtonsCtrl: _vm.drtLayersButtonsCtrl,
                            wclLayersButtonsCtrl: _vm.wclLayersButtonsCtrl,
                            map: _vm.map,
                            mmp_layersObj: _vm.mmp_layersObj,
                            selectedRelease: _vm.selectedRelease,
                            filterClassesObj: _vm.filterClassesObj,
                            layerResponse: _vm.layerResponse,
                            zoomEnded: _vm.zoomEnded,
                            zoomLevelCap: _vm.zoomLevelCap,
                            selectedExtent: _vm.selectedExtent,
                            persistingLayerFilters: _vm.persistingLayerFilters,
                            prod: _vm.prod,
                          },
                          on: {
                            filterClassesObjChanged: function ($event) {
                              _vm.filterClassesObj = $event
                            },
                            updateZoomEnded: function ($event) {
                              _vm.zoomEnded = $event
                            },
                            toggleLayerVisibility: function ($event) {
                              return _vm.toggleLayerVisibility($event)
                            },
                            loadAttributes: function ($event) {
                              return _vm.loadAttributes($event)
                            },
                            getShowAttributes: function ($event) {
                              return _vm.getShowAttributes($event)
                            },
                            layerButtonsChanged: function ($event) {
                              _vm.drtLayersButtonsCtrl = $event
                            },
                            toTopOfList: function ($event) {
                              return _vm.putLayerOnTop($event)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode && _vm.layerLegend
                      ? _c("MMP_LayerLegend", {
                          staticClass: "layer-legend-position p-1",
                          attrs: {
                            id: "layerLegend",
                            layerLegendMaxHeight: _vm.layerLegendMaxHeight,
                            layerLegendName: _vm.layerLegendName,
                            legendImgSrc: _vm.legendImgSrc,
                            legendMinimized: _vm.layerLegendMinimized,
                          },
                          on: {
                            closeLegend: function ($event) {
                              return _vm.closeLegend()
                            },
                            maximizeLegend: function ($event) {
                              return _vm.maxOrMinLegend(false)
                            },
                            minimizeLegend: function ($event) {
                              return _vm.maxOrMinLegend(true)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "Moveable",
                      _vm._b(
                        {
                          staticClass: "moveable attribute-table",
                          on: {
                            drag: function ($event) {
                              return _vm.handleDrag($event)
                            },
                          },
                        },
                        "Moveable",
                        _vm.moveable,
                        false
                      ),
                      [
                        _vm.showAttributes && _vm.mapsMode
                          ? _c(
                              "div",
                              {
                                staticClass: "moveable-container-attributes",
                                attrs: { id: "attributes" },
                              },
                              [
                                _c("Generic_Attributes", {
                                  attrs: {
                                    attributesName: _vm.attributesName,
                                    attributesMinimized:
                                      _vm.attributesPanelMinimized,
                                    attribResponse: _vm.attribResponse,
                                    features: _vm.features,
                                    feature_index: _vm.feature_index,
                                  },
                                  on: {
                                    closeAttTable: function ($event) {
                                      return _vm.closeAttTable()
                                    },
                                    maximizeAttributes: function ($event) {
                                      return _vm.maxOrMinAttributes(false)
                                    },
                                    minimizeAttributes: function ($event) {
                                      return _vm.maxOrMinAttributes(true)
                                    },
                                    showNextAttribute: function ($event) {
                                      return _vm.showNextAttribute($event)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("Generic_ReleaseModal", {
              attrs: { project_id: _vm.project_id, wclFlag: _vm.wclFlag },
              on: {
                datasetSelected: function ($event) {
                  return _vm.datasetSelected($event)
                },
                returnHome: function ($event) {
                  return _vm.showDashboard()
                },
              },
            }),
            _vm._v(" "),
            _c("DT_ChangePassword"),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("head", [
      _c("meta", {
        attrs: { "http-equiv": "Cache-Control", content: "no-cache" },
      }),
      _vm._v(" "),
      _c("meta", { attrs: { "http-equiv": "Pragma", content: "no-cache" } }),
      _vm._v(" "),
      _c("meta", { attrs: { "http-equiv": "Expires", content: "0" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }